import React from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import EligibilitySection from '../EligibilitySection'
import PopupHeader from 'Components/PopupHeader/PopupHeader'
import PopupFooter from 'Components/PopupFooter/PopupFooter'

const PatientEligibilityPopup = ({ patientId, onClose, singlePlan = null, patientName, getAllPlans, getPatientPlans, initialEligibilityResult = null }) => {
    const handleClose = () => {
        onClose()
        getPatientPlans()
    }
    const UNIQUE_ID = "PatientEligibilityPopup"
    return (
        <ReactPortal wrapperId={UNIQUE_ID}>
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={false} handle={`#${UNIQUE_ID}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-full min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        <div className='p-5 pt-0'>
                            <PopupHeader uniqueId={UNIQUE_ID} heading="Patient Eligibility" onClose={onClose} />
                            <div className="overflow-y-auto max-h-[70vh] pr-2 pb-6 space-y-4">
                                <EligibilitySection patientId={patientId} singlePlan={singlePlan} patientName={patientName} getAllPlans={getAllPlans} initialEligibilityResult={initialEligibilityResult} />
                            </div>
                            <PopupFooter onClose={handleClose} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>

    )
}

export default PatientEligibilityPopup